import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListaPropostasPJ from '../ListaPropostasPJ';



class ListaPropostasPJEmProcessamento extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {

    return (
      <ListaPropostasPJ history={this.props.history}/>
    );

  }

}

ListaPropostasPJEmProcessamento.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasPJEmProcessamento);